
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"42.111","viewBox":"0 0 40 42.111"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-0.416 2.111)"}},[_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","transform":"translate(0.416)","fill":"#fff500"}}),_c('text',{attrs:{"transform":"translate(21.416 29.889)","fill":"#010409","font-size":"34","font-family":"LondrinaSolid-Black, Londrina Solid","font-weight":"800"}},[_c('tspan',{attrs:{"x":"-6.171","y":"0"}},[_v('>')])])])])
          )
        }
      }
    